import { Box } from "@mui/material";
import { NonNullableDate } from "../../../../../../../../../utils/date-time-utility";
import {
  DEFAULT_BG_COLOR,
  DEFAULT_KEY_LABEL_COLOR,
  DEFAULT_LABEL_COLOR,
} from "../../../../../../../../../utils/utils";
import Text from "../../../../../../../../../components/Text";
import { TYPE_OPTION_MAPPER } from "../../../diagnoses/diagnosis-constant";

const DiagnosisRow: React.FC<{ label: string; value: React.ReactNode }> = ({
  label,
  value,
}) => (
  <Box
    sx={{
      display: "grid",
      gridTemplateColumns: "110px 8px 1fr",
      alignItems: "start",
    }}
  >
    <Text sx={{ color: DEFAULT_KEY_LABEL_COLOR }}>{label}</Text>
    <Text sx={{ color: DEFAULT_KEY_LABEL_COLOR }}>:</Text>
    <Text sx={{ color: "#222", wordBreak: "break-word" }}>{value}</Text>
  </Box>
);

export interface Diagnosis {
  uuid: string;
  medicalCode: {
    uuid: string;
    codeVersion: string;
    type: string;
    code: string;
    description: string;
    source: string | null;
    active: boolean;
    archive: boolean;
    errorMessage: string | null;
    drugId: string | null;
    formType: string | null;
    drugName: string | null;
    strength: string | null;
  };
  patient: Record<string, string>;
  name: string;
  diagnosisStatus: string | null;
  active: boolean;
  type: string;
  diagnosedDate: Date; // ISO date string
  note: string;
  archive: boolean;
  recordedDate: Date; // ISO date string
  modifiedDate: Date; // ISO date string
}

export const DiagnosisTooltip: React.FC<{ data: Diagnosis }> = ({ data }) => (
  <Box sx={{ minWidth: 250 }}>
    {/* Title Bar */}
    <Box
      sx={{
        background: DEFAULT_BG_COLOR,
        padding: "8px 12px",
      }}
    >
      <Text color={DEFAULT_LABEL_COLOR}>Diagnosis Details</Text>
    </Box>
    {/* Content */}
    <Box
      sx={{
        padding: "12px 16px",
        display: "flex",
        flexDirection: "column",
        gap: "4px",
      }}
    >
      <DiagnosisRow
        label="Diagnosis"
        value={data?.medicalCode?.code + " - " + data?.medicalCode?.description}
      />
      {/* <DiagnosisRow label="Problem" value={data?.name} /> */}
      <DiagnosisRow
        label="Type"
        value={TYPE_OPTION_MAPPER[data?.type] ?? data?.type}
      />
      <DiagnosisRow
        label="Diagnosis Date"
        value={NonNullableDate(data?.diagnosedDate)}
      />
      <DiagnosisRow
        label="Updated Date"
        value={NonNullableDate(data?.modifiedDate)}
      />
      <DiagnosisRow
        label="Status"
        value={data?.active ? "Active" : "Inactive"}
      />
      <DiagnosisRow label="Note" value={data?.note} />
    </Box>
  </Box>
);
